module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }